<div class="container">
  <div class="row justify-content-start">

    <!-- Change area -->
    <ng-container *ngIf="systemLevels && showAreaChange">

        <!-- System level selector -->
        <div class="col-sm-7 col-12">
          <button *ngFor="let level of systemLevels; trackBy: trackBySystemLevelId" [class]="level.SystemLevelID == systemLevelSelected?.SystemLevelID ? 'btn btn-sm btn-light me-2 mt-1' : 'btn btn-sm btn-outline-light me-2 mt-1'" (click)="selectSystemLevel(level.SystemLevelID)">
            {{ level.SystemLevelName }}
          </button>
          <button [class]="showingPractices ? 'btn btn-sm btn-light me-2 mt-1' : 'btn btn-sm btn-outline-light me-2 mt-1'" (click)="selectPracticeLevel()">
            Practice
          </button>
        </div>
        <div class="col-sm-5 col-12 text-sm-right">
          <button class="btn btn-sm btn-outline-light mt-1" (click)="hideAreaSelector()">
            <i class="far fa-times me-1"></i>Cancel
          </button>
        </div>

        <!-- England, STP, CCG and PCN -->
        <ng-container *ngIf="!showingPractices">
          <div class="col-12">
            <div class="mb-3 mt-3">
              <input type="text" class="form-control border border-white" [(ngModel)]="areaSearch" placeholder="Search selected level by name or code..." [disabled]="!systemLevelSelected || systemLevelSelected.SystemLevelID == 1">
            </div>
            <div *ngIf="areas && (areas | filterBy: ['AreaName']: areaSearch).length == 0" class="text-light mt-3">
              There are no {{ systemLevelSelected.SystemLevelName }}s matching this search.
            </div>
            <div class="position-relative mt-3 selector-scroll" *ngIf="!areasLoading">
              <div *ngFor="let area of areas | filterBy: ['AreaName']: areaSearch; trackBy: trackByAreaId" (click)="selectArea(area.AreaID)" class="selector-item">
                <button type="button">{{ area.AreaName }}</button>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Practices -->
        <ng-container *ngIf="showingPractices">
          <div class="col-12">
            <div class="mb-3 mt-3">
              <input type="text" class="form-control border border-white" [(ngModel)]="practiceSearch" placeholder="Search practices by name or code..." [disabled]="!practices">
              <div class="text-white small mt-2" style="opacity:0.75">
                <i class="fal fa-info-circle me-1"></i>If a practice is not listed, this is because it did not participate in providing data.
              </div>
            </div>
            <div *ngIf="practices && (practices | filterBy: ['AreaName']: practiceSearch).length == 0" class="text-light mt-3">
              There are no practices matching this search.
            </div>
            <div class="position-relative selector-scroll" *ngIf="!areasLoading">
              <div *ngIf="!practices" class="text-light mt-3">
                <div class="row">
                  <div class="col-md-6 col-12">
                    <div class="border border-white rounded hover-pointer py-2 px-3 mb-2" (click)="selectSystemLevel(4)">
                      <button type="button" class="btn btn-link text-white wrap">
                        <strong class="d-block mb-1">Select a PCN first</strong>
                        This will then show a list of practices within the selected PCN.
                      </button>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="border border-white rounded hover-pointer py-2 px-3 mb-2" (click)="getUnassignedAreas(periodSelected.TimePeriodID, 5)">
                      <button type="button" class="btn btn-link text-white wrap">
                        <strong class="d-block mb-1">Practices unassigned to a PCN</strong>
                        Click here to view practices that are not assigned to a PCN.
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="practices">
                <div *ngFor="let practice of practices | filterBy: ['AreaName']: practiceSearch; trackBy: trackByAreaId" (click)="selectPractice(practice.AreaID)" class="selector-item">
                <button type="button" class="btn btn-link">{{ practice.AreaName }}</button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

    </ng-container>

    <!-- Area selected -->
    <ng-container *ngIf="areaSelected && !showAreaChange">
      <div class="col-sm-9 col-12">
        <div class="text-white mb-1">
          {{ areaSelected.AreaCode }}: <strong>{{ areaSelected.AreaName }}</strong>
        </div>
        <div class="small selection-info">
          <div *ngIf="periodSelected" class="d-inline-block me-2">
            <span>Time Period</span>
            <span>{{ periodSelected.TimePeriodName }}</span>
          </div>
          <div *ngIf="areaSelected.ParticipationRate" class="d-inline-block me-2">
            <span>Practice Coverage</span>
            <span>{{ areaSelected.ParticipationRate }}%</span>
          </div>
          <div *ngIf="areaSelected.PopulationRate" class="d-inline-block">
            <span>Population Coverage</span>
            <span>{{ areaSelected.PopulationRate }}%</span>
          </div>
          <!-- Tooltip -->
          <ng-template #tipContent let-helpText="helpText">
            <a [routerLink]="['/methodology']" target="_blank" fragment="coverage" class="text-white">
              {{ helpText }}
            </a>
          </ng-template>
          <i class="far fa-lg fa-info-circle text-white ps-2 hover-pointer" [ngbTooltip]="tipContent" triggers="manual" #t1="ngbTooltip" (click)="toggleHelpText(t1, 'Click here to learn more about coverage')"></i>
        </div>
      </div>
      <div class="col-sm-3 col-12 text-sm-right">
        <button class="btn btn-sm btn-outline-light mt-1" (click)="changeArea(areaSelected.SystemLevelID)">
          Change time period or area<i class="fas fa-caret-down ms-1"></i>
        </button>
      </div>
    </ng-container>
  
    <!-- No area selected and no dropdown -->
    <ng-container *ngIf="!areaSelected && !showAreaChange">
      <div class="col-sm-7 col-12 text-white hover-pointer" (click)="changeArea(1)">
        <strong>Select your geographical area</strong>
        <div class="text-light small">
          Choose your STP, CCG, PCN or Practice
        </div>
      </div>
      <div class="col-sm-5 col-12 text-sm-right">
        <button class="btn btn-sm btn-outline-light mt-1" (click)="changeArea(1)">
          Select an area<i class="fas fa-caret-down ms-1"></i>
        </button>
      </div>
    </ng-container>
  
  </div>
</div>